export const navItems = [
  // { name: "Use Cases", href: "#" },
  { name: "Blog", href: "/blog" },
  { name: "Pricing", href: "/pricing" },
  { name: "Login", href: "/sign-in" },
];

export const THEME: { DEFAULT: 'light' | 'dark', LIGHT: 'light', DARK: 'dark' } = {
  DEFAULT: 'light',
  DARK: 'dark',
  LIGHT: 'light',
}

export const publicRoutes = [
  '/complete-onboarding',
  '/sign-in(.*)',
  '/sign-up(.*)',
  '/', '/privacy-policy',
  '/terms-of-service',
  '/blog(.*)',
  '/sitemap-0.xml',
  '/robots.txt',
  '/sitemap.xml',
  '/pricing'
];

// List of common personal email domains
export const PERSONAL_EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'protonmail.com',
  'mail.com',
  'zoho.com',
  'yandex.com',
  'live.com',
  'inbox.com',
  'gmx.com',
  'fastmail.com',
  'me.com'
];

export const mainPageFaq = [
  {
    question: "Who is Mardi? How does it help improve my Google Ads performance?",
    answer: "Mardi is your AI-powered marketing intern that analyzes your Google Ads traffic, identifies irrelevant search terms, and suggests negative keywords—so you stop wasting budget and get better leads."
  },
  {
    question: "Does Mardi replace my agency or in-house team?",
    answer: "Nope—Mardi makes them more effective. Think of it as giving your team superpowers, not replacing them."
  },
  {
    question: "How do I connect Mardi with my Google Ads account?",
    answer: "With just a few clicks. We use Google’s secure OAuth connection—no messy setup or manual imports."
  },
  {
    question: "Can I customize Mardi’s recommendations?",
    answer: "Yes. You stay in control. Mardi suggests keywords to block, but you decide what gets added."
  },
  {
    question: "Is my Google Ads data safe?",
    answer: "Absolutely. We follow industry-standard security protocols and never store sensitive data unnecessarily."
  },
  {
    question: "Is there a plan for agencies or multi-account setups?",
    answer: "Definitely. If you manage multiple ad accounts (like a marketing agency or growth team), we offer multi-account dashboards and volume discounts."
  },
  {
    question: "Will my clients know I’m using Mardi?",
    answer: "Not unless you want them to. Mardi runs in the background and doesn’t leave any visible footprint in your client accounts. That said, your clients will be happy to learn you are saving them more money using Mardi."
  },
];

export const pricingPageFaq = [
  {
    question: "How does Mardi identify wasted ad spend?",
    answer: "Mardi uses AI to analyze your search terms report, identifying keywords that are driving clicks but not conversions. It then suggests these as negative keywords to prevent future wasted spend.",
  },
  {
    question: "How much time will I save using Mardi?",
    answer: "Most customers save 5–10 hours per week that would otherwise be spent manually reviewing search terms and optimizing campaigns.",
  },
  {
    question: "Can I connect multiple ad accounts?",
    answer: "Yes, our Agency plan allows you to connect multiple ad accounts. The Pro plan is limited to a single account.",
  },
  {
    question: "Is there a contract or commitment?",
    answer: "No, all plans are month-to-month with no long-term commitment. You can upgrade, downgrade, or cancel at any time.",
  },
]